import { TopbarProps } from "@made-people/blueprint-topbar";

export const TopbarDefaults: TopbarProps = {
  settings: {
    template: "ticker",
  },
};
